import { useCallback,useState } from "react";

/**
 * Hook for managing row selection in DataTable.
 * @param {Function} getRowId - (row) => id
 * @returns {Object} selection - { selectedIds, selectedCount, isSelected, toggleSelection, selectAll, deselectAll }
 */
export const useDataTableSelection = (getRowId = (row) => row?.id ?? row?.key) => {
  const [selectedIds, setSelectedIds] = useState(new Set());

  const isSelected = useCallback(
    (id) => selectedIds.has(id),
    [selectedIds]
  );

  const toggleSelection = useCallback(
    // eslint-disable-next-line no-unused-vars -- row required by DataTable API
    (id, row, checked) => {
      setSelectedIds((prev) => {
        const next = new Set(prev);
        if (checked) {
          next.add(id);
        } else {
          next.delete(id);
        }
        return next;
      });
    },
    []
  );

  const selectAll = useCallback(
    (rows) => {
      setSelectedIds(new Set(rows.map((r) => getRowId(r))));
    },
    [getRowId]
  );

  const deselectAll = useCallback(() => {
    setSelectedIds(new Set());
  }, []);

  return {
    selectedIds,
    selectedCount: selectedIds.size,
    isSelected,
    toggleSelection,
    selectAll,
    deselectAll,
  };
};
